import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { BaseApiService } from './base-api.service';
import { AiGeneratedContentResponseDto } from '../../dto';
import { HttpParams } from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})
export class AiGeneratedContentAiService {

    constructor(private readonly baseApiService: BaseApiService) { }

    getAiGenerateContent(): Observable<AiGeneratedContentResponseDto[]> {
        return this.baseApiService.get<AiGeneratedContentResponseDto[]>(`service/contactcloud/contentset/list`);
    }

    deleteAiGenerateContent(contentSetId: number): Observable<{ response: string }> {
        const httpParams = new HttpParams()
            .set('id', contentSetId.toString());
        return this.baseApiService.delete<{ response: string }>(`service/contactcloud/contentset`, {params: httpParams});
    }
}
